export default {
  root: {
    boxShadow: 'none',
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
};
